import  { useEffect, useState } from "react";
import axios from "axios";
import { SHEET_ID, SHEET_KEY } from "../../lib/config";
// import mainLogo from "../../assets/ClickHunts.png";

const GoogleSheetAPI = () => {
  // const [values, setValues] = useState([]);
  const [structured, setStructured] = useState({
    categories: [],
    offersFlat: [],
    stats: {
      activeOffers: 0,
      categories: 0,
      highestPayout: "—",
      maxRevShare: "—",
    },
    lastUpdated: null,
    headers: [],
  });
  const [loading, setLoading] = useState(true);

  // modal to show long cell content (restrictions etc)
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState("");

  const API_KEY = SHEET_KEY;
  const SHEET_NAME = "Sheet1";
  // const tableRef = useRef(null);

  const parseSheetValues = (vals) => {
    if (!Array.isArray(vals) || vals.length <= 1) {
      return {
        categories: [],
        offersFlat: [],
        stats: {
          activeOffers: 0,
          categories: 0,
          highestPayout: "—",
          maxRevShare: "—",
        },
        lastUpdated: null,
        headers: [],
      };
    }

    const headers = vals[1] || [];
    const rows = vals.slice(2);

    const asText = (v) =>
      v === null || v === undefined ? "" : String(v).trim();
    const isEmptyRow = (r) => !r || r.every((c) => asText(c) === "");
    const isSectionHeaderRow = (r) => {
      if (!r) return false;
      const nonEmpty = r.filter((c) => asText(c) !== "");
      if (nonEmpty.length === 1) {
        const val = asText(nonEmpty[0]).toLowerCase();
        return /top offer|top offers|brand bidding|cod|health|ecommerce|credit score/i.test(
          val
        );
      }
      return false;
    };

    const headerIndexOf = (name) => {
      const low = name.toLowerCase();
      return headers.findIndex((h) =>
        (h || "").toString().toLowerCase().includes(low)
      );
    };

    const idxStatus = headerIndexOf("status");
    const idxOfferId = headerIndexOf("offer id");
    const idxOfferName = headerIndexOf("offer name");
    const idxPayout = headerIndexOf("payout");
    const idxModel = headerIndexOf("model");
    const idxAllowedTraffic =
      headerIndexOf("allowed traffic") >= 0
        ? headerIndexOf("allowed traffic")
        : headerIndexOf("allowed");
    const idxTopCountry =
      headerIndexOf("top country") >= 0
        ? headerIndexOf("top country")
        : headerIndexOf("country");
    const idxMedia = headerIndexOf("media");
    const idxCategory = headerIndexOf("category");
    const idxRestriction = headerIndexOf("restriction");

    const splitList = (s) =>
      (s || "")
        .toString()
        .split(/[;,]/)
        .map((x) => x.trim())
        .filter(Boolean);

    const parsePayoutNumber = (s) => {
      if (!s) return null;
      const raw = String(s);
      if (raw.includes("%")) {
        const n = parseFloat(raw.replace(/[^0-9.]/g, ""));
        return Number.isFinite(n) ? { value: n, type: "percent", raw } : null;
      } else {
        const n = parseFloat(raw.replace(/[^0-9.]/g, ""));
        return Number.isFinite(n) ? { value: n, type: "currency", raw } : null;
      }
    };

    const categories = [];
    let currCategory = { name: "Uncategorized", offers: [] };
    const offersFlat = [];
    let lastUpdated = null;

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      if (isEmptyRow(row)) continue;

      const firstCell = asText(row[0]).toLowerCase();
      if (firstCell.includes("last updated")) {
        lastUpdated = asText(row[0]);
        continue;
      }

      if (isSectionHeaderRow(row)) {
        if (currCategory && currCategory.offers.length > 0)
          categories.push(currCategory);
        currCategory = { name: asText(row[0]), offers: [] };
        continue;
      }

      const status = idxStatus >= 0 ? asText(row[idxStatus]) : asText(row[0]);
      const offerId =
        idxOfferId >= 0 ? asText(row[idxOfferId]) : asText(row[1] || "");
      const offerName =
        idxOfferName >= 0 ? asText(row[idxOfferName]) : asText(row[2] || "");
      const payoutRaw =
        idxPayout >= 0 ? asText(row[idxPayout]) : asText(row[3] || "");
      const model =
        idxModel >= 0 ? asText(row[idxModel]) : asText(row[4] || "");
      const allowedTrafficRaw =
        idxAllowedTraffic >= 0
          ? asText(row[idxAllowedTraffic])
          : asText(row[5] || "");
      const topCountry =
        idxTopCountry >= 0 ? asText(row[idxTopCountry]) : asText(row[6] || "");
      const mediaRaw =
        idxMedia >= 0 ? asText(row[idxMedia]) : asText(row[7] || "");
      const categoryCell =
        idxCategory >= 0 ? asText(row[idxCategory]) : asText(row[8] || "");
      const restrictionRaw =
        idxRestriction >= 0
          ? asText(row[idxRestriction])
          : asText(row[9] || "");

      const offer = {
        status,
        offerId,
        offerName,
        payoutRaw,
        payout: parsePayoutNumber(payoutRaw),
        model,
        allowedTrafficRaw,
        allowedTraffic: splitList(allowedTrafficRaw),
        topCountry,
        mediaRaw,
        media: splitList(mediaRaw),
        categoryCell,
        restrictionRaw,
        raw: row.slice(),
      };

      offersFlat.push(offer);
      if (!currCategory)
        currCategory = { name: categoryCell || "Uncategorized", offers: [] };
      if (
        (currCategory.name === "Uncategorized" || !currCategory.name) &&
        categoryCell
      )
        currCategory.name = categoryCell;
      currCategory.offers.push(offer);
    }

    // push last category
    if (currCategory && currCategory.offers.length > 0)
      categories.push(currCategory);

    // compute stats
    const stats = {
      activeOffers: 0,
      categories: categories.length,
      highestPayout: "—",
      maxRevShare: "—",
    };
    stats.activeOffers = offersFlat.filter(
      (o) => (o.status || "").toLowerCase() === "active"
    ).length;

    let maxCurrency = -Infinity;
    let maxPercent = -Infinity;
    let anyCurrency = false;
    offersFlat.forEach((o) => {
      if (o.payout) {
        if (o.payout.type === "currency") {
          anyCurrency = true;
          if (o.payout.value > maxCurrency) maxCurrency = o.payout.value;
        } else if (o.payout.type === "percent") {
          if (o.payout.value > maxPercent) maxPercent = o.payout.value;
        }
      }
    });
    if (anyCurrency && maxCurrency !== -Infinity)
      stats.highestPayout = `$${maxCurrency}`;
    else if (maxPercent !== -Infinity) stats.highestPayout = `${maxPercent}%`;
    stats.maxRevShare = maxPercent !== -Infinity ? `${maxPercent}%` : "—";

    return { categories, offersFlat, stats, lastUpdated, headers };
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${SHEET_NAME}?key=${API_KEY}`
        );
        const vals = res.data.values || [];
        // setValues(vals);

        const parsed = parseSheetValues(vals);
        setStructured({
          categories: parsed.categories,
          offersFlat: parsed.offersFlat,
          stats: parsed.stats,
          lastUpdated: parsed.lastUpdated,
          headers: parsed.headers || [],
        });

        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch Google Sheet data", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [API_KEY]);

  const openModal = (title, body) => {
    setModalTitle(title);
    setModalBody(body);
    setModalOpen(true);
  };
  const closeModalHandler = () => {
    setModalOpen(false);
    setModalTitle("");
    setModalBody("");
  };

  const renderHeaderRow = (headers) => {
    if (!Array.isArray(headers) || headers.length === 0) return null;
    return (
      <tr className="bg-gradient-to-r from-[#048998] to-[#036d7a] text-white">
        {headers.map((h, hi) => (
          <th
            key={hi}
            className="px-3 py-2 font-bold text-[14px] border-b border-[#03808e]"
          >
            <div className="truncate">{h}</div>
          </th>
        ))}
      </tr>
    );
  };

  return (
    <div className="font-sans bg-white rounded-xl overflow-hidden mx-auto max-w-7xl my-8 shadow-[0_4px_24px_rgba(0,0,0,0.08)] text-center">
      <div className="bg-white text-center">
        <div className="inline-block px-8 py-6 rounded-lg">
          <h2 className="text-[28px] md:text-[48px] font-bold text-[#048998] relative after:content-[''] after:absolute after:left-0 after:right-0 after:-bottom-[10px] after:h-[4px] after:bg-gradient-to-r after:from-transparent after:via-[#048998] after:to-transparent">
            ClickHunts Weekly Performance Offer
          </h2>
        </div>
      </div>

      {/* Offers */}
      <div className="px-8 py-8">
        <div className="max-w-6xl mx-auto">
          {loading ? (
            <div className="text-center py-10">Loading...</div>
          ) : structured.categories.length === 0 ? (
            <div className="text-center py-10">No offers found.</div>
          ) : (
            structured.categories.map((cat, ci) => (
              <div
                key={ci}
                className="mb-6 bg-white shadow-lg rounded-3xl overflow-hidden"
              >
                <div className="bg-gradient-to-r from-[#f0fafb] to-[#eef8f8] px-6 py-8 border-b border-[#e6f0f0] shadow-sm">
                  <div className="flex items-center gap-4 ">
                    <div className="h-8 aspect-[1/4] rounded-full bg-gradient-to-br from-[#048998] to-[#025c66] shadow-md" />
                    <h3 className="text-[24px] font-bold text-[#048998] text-center">
                      {cat.name}
                    </h3>
                  </div>
                </div>

                <div className="overflow-x-auto shadow-inner">
                  <table className="w-full table-fixed divide-y line-clamp-3 font-semibold text-[14px] overflow-x-scroll" >
                    <thead>
                      {renderHeaderRow(cat.headers || structured.headers)}
                    </thead>
                    <tbody>
                      {cat.offers.map((offer, oi) => {
                        const isActive =
                          (offer.status || "").toLowerCase() === "active";
                        const isPause =
                          (offer.status || "").toLowerCase() === "pause";
                        return (
                          <tr
                            key={oi}
                            className={`${
                              isPause
                                ? "bg-red-50"
                                : oi % 2 === 0
                                ? "bg-white"
                                : "bg-[#fbfefe]"
                            } hover:bg-[#f0f9fa]`}
                          >
                            {/* render one td per header to keep alignment */}
                            {(cat.headers || structured.headers || []).map(
                              (h, hi) => {
                                const key = `c${ci}-r${oi}-c${hi}`;
                                let cellContent = "—";
                                switch (hi) {
                                  case 0:
                                    cellContent = offer.status || "—";
                                    break;
                                  case 1:
                                    cellContent = offer.offerId || "—";
                                    break;
                                  case 2:
                                    cellContent = offer.offerName || "—";
                                    break;
                                  case 3:
                                    cellContent = offer.payoutRaw || "—";
                                    break;
                                  case 4:
                                    cellContent = offer.model || "—";
                                    break;
                                  case 5:
                                    cellContent =
                                      offer.allowedTrafficRaw || "—";
                                    break;
                                  case 6:
                                    cellContent = offer.topCountry || "—";
                                    break;
                                  case 7:
                                    cellContent = offer.mediaRaw || "—";
                                    break;
                                  case 8:
                                    cellContent =
                                      offer.categoryCell || cat.name || "—";
                                    break;
                                  case 9:
                                    cellContent = offer.restrictionRaw || "—";
                                    break;
                                  default:
                                    cellContent = "—";
                                }

                                if (hi === 9) {
                                  const hasRestriction =
                                    cellContent && cellContent !== "—";
                                  return (
                                    <td
                                      key={key}
                                      className="p-3 text-xs align-top w-[220px] text-center"
                                    >
                                      {hasRestriction ? (
                                        <button
                                          onClick={() =>
                                            openModal(
                                              "Restriction",
                                              cellContent
                                            )
                                          }
                                          className="text-[#048998] underline text-sm"
                                        >
                                          View Restrictions
                                        </button>
                                      ) : (
                                        <div className="text-gray-500">—</div>
                                      )}
                                    </td>
                                  );
                                }

                                if (hi === 0) {
                                  return (
                                    <td
                                      key={key}
                                      className="p-3 text-xs align-top w-[110px] text-center font-semibold text-[14px]"
                                    >
                                      {isActive ? (
                                        <div className="flex items-center justify-center text-emerald-600 font-medium">
                                          <span className="w-2 h-2 rounded-full bg-emerald-500 mr-2 animate-pulse" />
                                          Active
                                        </div>
                                      ) : isPause ? (
                                        <div className="flex items-center justify-center text-red-600 font-medium">
                                          <span className="w-2 h-2 rounded-full bg-red-500 mr-2" />
                                          Pause
                                        </div>
                                      ) : (
                                        <div className="text-gray-600">
                                          {cellContent}
                                        </div>
                                      )}
                                    </td>
                                  );
                                }

                                return (
                                  <td
                                    key={key}
                                    className="p-3 text-xs align-top text-center"
                                  >
                                    <div
                                      className={
                                        hi === 2
                                          ? "font-semibold text-[#048998]"
                                          : ""
                                      }
                                    >
                                      {cellContent}
                                    </div>
                                  </td>
                                );
                              }
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* CTA */}
      <div className="py-8 text-center bg-white">
        <div
          className="inline-block bg-gradient-to-br from-[#048998] to-[#025c66] rounded-full p-1 shadow-md"
        >
          <span className="block px-8 py-3 rounded-full font-bold tracking-wider bg-[#048998] text-white transition">
            {structured.lastUpdated}
          </span>
        </div>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full overflow-auto">
            <div className="flex justify-between items-center px-6 py-4 bg-gradient-to-r from-[#048998] to-[#036d7a] text-white">
              <h4 className="font-bold text-center w-full">{modalTitle}</h4>
              <button
                onClick={closeModalHandler}
                className="text-white text-2xl leading-none"
              >
                ×
              </button>
            </div>
            <div className="p-6 text-sm whitespace-pre-wrap text-center">{modalBody}</div>
            <div className="p-4 border-t text-right">
              <button
                onClick={closeModalHandler}
                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GoogleSheetAPI;